/* assets/combo-pods.js — Petal Combo -> Pods auto-add (STABLE v1, 2026-10-22)
 * Replaces bundle-addon.js on the US theme. The old script only added the
 * companion Pods line when the cart-add carried a non-empty selling plan,
 * which rarely happened, so Pods never auto-added. This version adds the
 * mapped Pods variant on EVERY Petal combo add (one-time OR subscription),
 * guards against duplicates, and avoids re-adding on plain page loads.
 * Config: BUNDLE_CONFIG maps combo variant id -> Pods variant id.
 */
(function () {
  'use strict';
  var BUNDLE_CONFIG = {
    '44468312047772': '44572222029980',  // Petal Ultrasonic Combo (one-time) -> Pods
    '44546519761052': '44656247079068'   // Petal Ultrasonic Combo (subscribe) -> Pods
  };
  var ADDING = false;
  var lastMutation = 0;

  function comboVariantOf(data) {
    try {
      if (data.items && Array.isArray(data.items)) {
        for (var i = 0; i < data.items.length; i++) {
          var id = data.items[i].id ? String(data.items[i].id) : null;
          if (id && BUNDLE_CONFIG[id]) return id;
        }
        return null;
      }
      var vid = data.id ? String(data.id) : null;
      return vid && BUNDLE_CONFIG[vid] ? vid : null;
    } catch (e) { return null; }
  }
  function cartHasVariant(variant) {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) return false; return r.json(); })
      .then(function (c) {
        return (c.items || []).some(function (it) { return String(it.variant_id) === String(variant); });
      })
      .catch(function () { return false; });
  }
  function addPodsIfMissing(variant) {
    if (ADDING || !variant) return Promise.resolve();
    ADDING = true;
    return cartHasVariant(variant).then(function (present) {
      if (present) return false;
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant, quantity: 1 })
      }).then(function () { return true; }).catch(function () { return false; });
    }).catch(function () { return false; }).finally(function () { ADDING = false; });
  }
  function freshCartHasComboWithoutPods() {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return false;
        var combo = null;
        for (var i = 0; i < c.items.length; i++) {
          var vid = String(c.items[i].variant_id);
          if (BUNDLE_CONFIG[vid]) combo = BUNDLE_CONFIG[vid];
        }
        if (!combo) return false;
        var hasPods = c.items.some(function (it) { return String(it.variant_id) === String(combo); });
        if (hasPods) return false;
        lastMutation = 0; // only act on a genuine recent mutation
        return combo;
      })
      .catch(function () { return false; });
  }
  function scheduleCheck() {
    lastMutation = Date.now();
    setTimeout(function () {
      if (Date.now() - lastMutation > 6000) return; // stale mutation, skip
      freshCartHasComboWithoutPods().then(function (v) { if (v) addPodsIfMissing(v); });
    }, 1200);
  }
  var originalFetch = (window.fetch && window.fetch.bind(window)) || null;
  if (!originalFetch) return;
  window.fetch = function (input, init) {
    var url = '';
    try { url = String((input && (input.url || input)) || ''); } catch (e) {}
    if (/\/cart\/add\.js(\?|$)/i.test(url)) {
      var body = null;
      try { body = typeof init.body === 'string' ? JSON.parse(init.body) : (init.body || null); } catch (e) {}
      var combo = body ? comboVariantOf(body) : null;
      if (combo) {
        scheduleCheck();
        return originalFetch.apply(this, arguments).then(function (response) {
          try { if (response.ok) addPodsIfMissing(BUNDLE_CONFIG[combo]); } catch (e) {}
          return response;
        });
      }
    }
    return originalFetch.apply(this, arguments);
  };
  try {
    document.addEventListener('cart:updated', scheduleCheck);
    document.addEventListener('cart:refresh', scheduleCheck);
    window.addEventListener('pageshow', scheduleCheck);
    document.addEventListener('DOMContentLoaded', scheduleCheck);
  } catch (e) {}
  scheduleCheck();
})();